<template>
  <div class="login-page tw:h-screen tw:flex tw:flex-col">
    <AccountMenu :is-mobile="isMobile" :redirection="{ path: '/register', text: translations.register.action }" />

    <div class="tw:flex tw:flex-col tw:flex-1 tw:bg-white tw:w-full tw:max-w-[160rem] tw:mx-auto" role="main">
      <div
        aria-label="login form"
        class="tw:h-full tw:flex tw:items-center tw:justify-center tw:bg-white tw:p-4"
        data-testid="login-page"
        role="region"
      >
        <div class="tw:sm:max-w-lg tw:md:max-w-md tw:mx-auto tw:flex tw:flex-col tw:w-full">
          <AccountContent :is-mobile="isMobile" :subtitle="translations.subtitle" :title="translations.title">
            <AccountLoginForm :is-mobile="isMobile" @register="gotoRegister" />
          </AccountContent>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useIsScreenMobile } from "vue-app/composables/useIsScreenMobile/useIsScreenMobile.composable";
import AccountLoginForm from "vue-app/components/Account/AccountLoginForm.vue";
import AccountMenu from "vue-app/components/Account/AccountMenu.vue";
import AccountContent from "vue-app/components/Account/AccountContent.vue";

export default defineComponent({
  name: "PageLogin",
  components: {
    AccountLoginForm,
    AccountMenu,
    AccountContent,
  },
  setup() {
    const translations = window._trans._account.login;
    const { isMobile } = useIsScreenMobile();

    function gotoRegister() {
      window.location.href = "/register";
    }

    return {
      gotoRegister,
      isMobile,
      translations,
    };
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account";

.AccountContent {
  width: 100% !important;
  max-width: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.login-page {
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 12px;
  }

  @media (min-width: 1536px) {
    font-size: 16px;
  }

  @media (min-width: 1920px) {
    font-size: 17px;

    .EdroneButton {
      height: 100%;
    }
  }

  @media (min-width: 2560px) {
    font-size: 17px;
  }

  @media (min-width: 3840px) {
    font-size: 20px;
  }

  @media (min-width: 5120px) {
    font-size: 24px;
  }
}
</style>
